import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { useDeviceMutation } from '@/hooks/useDeviceMutation';
import { SectionHeader, Field } from './SectionHeader';
import type { DeviceStatus } from '@/lib/types';

interface Props { device: DeviceStatus; disabled: boolean }

export function CycleTimingSection({ device, disabled }: Props) {
  const [overlapMs, setOverlapMs] = useState<number>(device.cycleTiming?.overlapMs ?? 1000);
  useEffect(() => {
    if (device.cycleTiming?.overlapMs !== undefined) setOverlapMs(device.cycleTiming.overlapMs);
  }, [device.cycleTiming?.overlapMs]);

  const mut = useDeviceMutation<{ overlapMs: number }>(
    device.client_id, 'cycle-timing', { successToast: 'Cycle timing saved' },
  );

  return (
    <div className="space-y-5">
      <SectionHeader title="Cycle timing"
        description="Overlap is how early (ms) the next relay turns ON before the previous one turns OFF. Set to 0 for no overlap." />
      <Field label="Relay overlap (ms)" hint="Ignored for relays marked Always-ON.">
        <Input type="number" min={0} max={10000} value={overlapMs} disabled={disabled}
          onChange={(e) => setOverlapMs(Math.max(0, parseInt(e.target.value || '0', 10)))} />
      </Field>
      <Button onClick={() => mut.mutate({ overlapMs })} loading={mut.isPending} disabled={disabled || mut.isPending}>
        Save cycle timing
      </Button>
    </div>
  );
}
